import React, { useState } from "react";
import { getAuswahlData } from "./MHelper";
import { Option, OptionSelect, TitleBlock } from "./OptionSelect";
import { PositionInput } from "../components/zauneditor/ZaunCircleMenuItemProfil";
import { MAuswahlwert } from "../../metamodell";
import { isEmpty } from "oc-commons/Commons";
import { getRichProfilkategorien } from "../arrangement/elementFunctions";

/**
 * Auswahlen für Dekorprofile (braucht eigene Implementierung wegen der Kategorien
 * und für Profilleiste (abhängig von Dekorprofil)
 */
export function OptionenContentDekorprofile() {
  const konf = APP.arrangement.konfiguration;
  const currentElement = APP.arrangement.getCurrentElement();

  const titleKey = "Profilkategorie";
  const auswahlData = getAuswahlData(titleKey);

  const profilkategorien = getRichProfilkategorien(true);
  const keinProfilkategorie = profilkategorien.find(
    (pk) => pk.kategorieAuswahlwert.Key == "KEIN_DEKORPROFIL"
  );
  const profilkategorienAuswahlwerte = profilkategorien.map((pk) => pk.kategorieAuswahlwert);
  const [openProfilkategorie, setOpenProfilkategorie] = useState(keinProfilkategorie);

  if (
    openProfilkategorie?.kategorieAuswahlwert != null &&
    !_.includes(profilkategorienAuswahlwerte, openProfilkategorie?.kategorieAuswahlwert)
  ) {
    setOpenProfilkategorie(keinProfilkategorie);
  }

  APP.on("menuSelect", (menuIndex: number, lastMenuIndex: number, pageKey: string) => {
    const currentElement = APP.arrangement?.getCurrentElement();
    if (currentElement.showProfil && currentElement?.profilKategorieAuswahlwert) {
      const profilkategorien = getRichProfilkategorien(true);
      const currentProfilkategorie = profilkategorien.find(
        (pk) => pk.kategorieAuswahlwert == currentElement.profilKategorieAuswahlwert
      );
      setOpenProfilkategorie(currentProfilkategorie);
    }
  });

  let profilleisteAuswahlwerte = openProfilkategorie?.profilleisteAuswahlwerte;
  // Für Keramik XL muss Profilabstand immer angezeigt werden:
  if (currentElement.isKeramikXL && openProfilkategorie?.kategorieAuswahlwert.Leeroption)
    profilleisteAuswahlwerte = profilkategorien.find(
      (pk) => !isEmpty(pk.profilleisteAuswahlwerte)
    ).profilleisteAuswahlwerte;

  if (profilkategorien.length < 2) return <></>;

  return (
    <section className={"optionSelect " + titleKey} aria-labelledby="dekorprofile-title">
      <TitleBlock auswahlData={auswahlData} />
      <fieldset className="options categorized">
        <legend className="sr-only">{I18N("Profilkategorie auswählen")}</legend>
        {profilkategorien.map((profilkategorie, index) => (
          <Option
            key={index}
            optionKey={"Profilkategorie"}
            auswahlwert={profilkategorie.kategorieAuswahlwert}
            selectFunction={() => {
              setOpenProfilkategorie(profilkategorie);
              if (profilkategorie.kategorieAuswahlwert.Key == "KEIN_DEKORPROFIL") {
                konf.setAuswahlwert("Profil", null);
              }
            }}
            isSelected={
              openProfilkategorie?.kategorieAuswahlwert == profilkategorie.kategorieAuswahlwert
            }
          />
        ))}
      </fieldset>
      {currentElement.showProfil && (
        <div className="MassProfilPosition" role="group" aria-labelledby="profil-position-label">
          <label id="profil-position-label" className="MassProfilPositionLabel">
            {I18N("Profil Position")}:
          </label>
          <div className={"MassProfilPositionInputWrapper"}>
            <PositionInput
              key={currentElement.id + "Dekorprofilposition"}
              value={
                currentElement.profilPosition != null
                  ? currentElement.profilPosition
                  : currentElement.sonderprofilMinMax.maxPosition
              }
              setter={(value) => {
                currentElement.profilPosition = value as number | "center";
                APP.arrangement.profilPosition_ = value as number | "center" | null;
              }}
            />
          </div>
        </div>
      )}
      <OptionSelect
        optionKey={"Profil"}
        options={openProfilkategorie?.profilAuswahlwerte}
        noTitleBlock={true}
        selectFunction={(what: string, auswahlwert: MAuswahlwert) => {
          konf.setAuswahlwert("Profilkategorie", openProfilkategorie?.kategorieAuswahlwert);
          konf.setAuswahlwert("Profil", auswahlwert);
        }}
      />
      <OptionSelect optionKey={"Profilleiste"} options={profilleisteAuswahlwerte} />
    </section>
  );
}
